import './notification.scss';

import React from 'react';
import { GoPrimitiveDot } from 'react-icons/go';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';

import { notificationShape } from '../../prop-types';
import { UI_DATE_FORMAT } from '../../utils/constants';
import pluralize from '../../utils/pluralize';
import storedUserInfo from '../../utils/session-data/user-info';

function Notification({ model }) {
  const { objectId, contentType, text, created, mentions } = model;
  const currentUser = storedUserInfo.get();
  const currentUserMention = mentions.find(_ => _.userId === currentUser.id);
  const isUnread = currentUserMention.status === 'unread';

  return (
    <Link
      className="c-notification"
      to={`/${pluralize(contentType)}/${objectId}/show?comments=open`}
    >
      <span className="c-notification__link-text">{text}</span>
      <span className="text-body small">
        <Moment fromNow withTitle titleFormat={`${UI_DATE_FORMAT} LTS`}>
          {created}
        </Moment>
      </span>
      {isUnread && <GoPrimitiveDot className="c-notification__unread-symbol" />}
    </Link>
  );
}

Notification.propTypes = {
  model: notificationShape.isRequired,
};

export default Notification;
